// @flow

import * as React from 'react';
import SailCheckbox from 'sail/Checkbox';
import {usePersistentState} from 'docs/data';
import './Checkbox.scss';

type CheckboxesState = {[name: string]: boolean};

type CheckboxProps = {|
  id: string,
  title: string,
  description?: string,
  disabled?: boolean,
  checked?: boolean,
  children?: React.Node,
|};

export const Checkbox = ({
  id,
  title,
  description,
  checked,
  disabled,
  children,
}: CheckboxProps) => {
  const [
    checkboxes,
    setCheckboxes,
    isLoading,
  ] = usePersistentState<CheckboxesState>('checkboxes', {});

  const handleChange = (event) => {
    setCheckboxes({
      ...checkboxes,
      [id]: event.target.checked,
    });
  };

  return (
    <span
      className="MarkdocCheckbox"
      style={{display: 'flex', alignItems: 'center'}}
    >
      <SailCheckbox
        checked={!!(checkboxes[id] || checked)}
        onChange={handleChange}
        label={<span className="CheckboxLabel">{children || title}</span>}
        description={description}
        disabled={isLoading || disabled}
      />
    </span>
  );
};
